import React, { Fragment, useContext, useEffect, useState } from 'react';
import { OutageActions } from '../outage-actions';
import { OutageFAQ } from '../outage-faq';
import { OutageSummaryFooter } from '../outage-summary-footer';
import { GetMobileApp } from '../get-mobile-app';
import { useOutageLeftPanelState } from '../../providers/OutageLeftPanelStateProvider';
import { ReportedOutageInfo } from '../reported-outage-info';
import { useAccountDetailsList } from '../../hooks/useAccountDetailsList';
import Backdrop from '../../../backdrop';
import { SingleAccountOutageDetails } from '../single-account-outage-details';
import { MultiAccountOutageDetails } from '../multi-account-outage-details';
import { useOutageAccountListContext } from '../../providers/OutageAccountListProvider';
import { TransitionContext } from '../../../../providers/TransitionProvider';
import { Loader } from '../../../my-programs/components/Loader';
import { Box } from '@material-ui/core';

export default function SecureLeftPanelContent() {
  const {
    panelOpen,
    outageMarkerView,
    selectedAccountForOutage,
    setSelectedAccountForOutage,
  } = useOutageLeftPanelState();
  const hasKnownOutage =
    selectedAccountForOutage?.premiseInfos?.[0]?.servicePointDetails?.[0]
      ?.outageInfo?.hasKnownOutage;
  const residentialOutageState = {
    hasOutage: hasKnownOutage ?? false,
    nestedOutage: selectedAccountForOutage?.nestedOutageStatusCode,
  };
  const { setState: updateTransition } = useContext(TransitionContext);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const {
    accountListWithOutageInfo: accounts,
    loading: accountListLoading,
    refetchAccountList,
  } = useAccountDetailsList();
  const urlParams: any = new URLSearchParams(window.location.search);
  const accountParam = urlParams.get('account');

  const {
    accountListWithOutageInfo,
    setAccountListWithOutageInfo,
  } = useOutageAccountListContext();
  const isSingleAccount = accounts?.length === 1;

  const refetchAccountsOutageInfo = () => {
    updateTransition({ open: true });
    setIsLoading(true);
    void refetchAccountList();
  };

  useEffect(() => {
    if (accounts?.length) {
      setIsLoading(false);
      updateTransition({ open: false });

      setAccountListWithOutageInfo(accounts);
      if (isSingleAccount) {
        const primaryAccount = accounts.find(
          account => account.isPrimaryAccount,
        );

        if (primaryAccount) {
          setSelectedAccountForOutage(primaryAccount);
        } else {
          setSelectedAccountForOutage(undefined);
        }
      }

      if (accountParam) {
        const selectedAccount = accounts.find(
          acc => acc.accountNumber === accountParam,
        );
        if (selectedAccount) {
          setSelectedAccountForOutage(selectedAccount);
        }
      }
    }
  }, [accounts]);

  return (
    <Fragment>
      {/* {accountListLoading && <Backdrop forceOpen />} */}
      {outageMarkerView ? (
        <ReportedOutageInfo />
      ) : (
        <>
          {accountListLoading || isLoading ? (
            <Box margin={4}>
              <Loader />
            </Box>
          ) : (
            <>
              {accounts.length > 0 && (
                <>
                  {isSingleAccount ? (
                    <SingleAccountOutageDetails
                      residentialOutageState={residentialOutageState}
                    />
                  ) : (
                    <MultiAccountOutageDetails
                      accountListWithOutageInfo={
                        accountListWithOutageInfo ?? []
                      }
                      refetchAccountsOutageInfo={refetchAccountsOutageInfo}
                    />
                  )}
                </>
              )}
            </>
          )}
        </>
      )}
      <OutageActions hasOutage={hasKnownOutage || undefined} />
      <OutageFAQ />
      {panelOpen && (
        <>
          <GetMobileApp />
          <OutageSummaryFooter />
        </>
      )}
    </Fragment>
  );
}
